import { useEffect } from 'react';

/**
 * Shows the browser's native "leave site?" dialog on tab close or reload while `shouldPrompt` is true.
 * Browsers ignore custom text for this dialog; only the generic one is shown.
 */
export const useBeforeUnload = (shouldPrompt: boolean): void => {
    useEffect(() => {
        if (!shouldPrompt) {
            return undefined;
        }

        const handleBeforeUnload = (event: BeforeUnloadEvent) => {
            event.preventDefault();
            event.returnValue = '';
        };

        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, [shouldPrompt]);
};
